import React from "react";
import Situation from "../../components/common/Situation";

const AuctionSituations = () => {
  return <Situation type={"auction"} />;
};

export default AuctionSituations;
